// GERADO de backend-senne/src/contracts — NÃO editar; rode scripts/sync-contracts.sh

import { z } from 'zod'
import { ERP_TREE_CODES } from './erp-tree'

/**
 * Spec 20261015-160924 AC-6: who sees what in the ERP, set per person in the Usuários screen. A node is granted,
 * denied, or has no explicit state and inherits from the nodes above it.
 */
export const erpNodeStateSchema = z.enum(['grant', 'deny'])
export type ErpNodeState = z.infer<typeof erpNodeStateSchema>

/** GET /users/:id/erp-permissions. */
export const userErpPermissionsSchema = z
    .object({
        /** The caller may change this person's ERP access. */
        editable: z.boolean(),
        /** The person can receive ERP access: the ERP is the Operação's. */
        eligible: z.boolean(),
        /** The explicit states only; a node absent here inherits. */
        nodes: z.record(z.string(), erpNodeStateSchema),
        /** The tree codes the person holds, in the tree's order: what they see in the ERP. */
        effective: z.array(z.string()),
    })
    .strict()
export type UserErpPermissions = z.infer<typeof userErpPermissionsSchema>

/** PUT /users/:id/erp-permissions: only the nodes that change; `inherit` removes a node's explicit state. */
export const setUserErpPermissionsSchema = z
    .object({
        nodes: z
            .record(z.string(), z.enum(['grant', 'deny', 'inherit']))
            .refine((nodes) => Object.keys(nodes).length > 0, {
                message: 'Nenhuma mudança enviada.',
            })
            .refine(
                (nodes) =>
                    Object.keys(nodes).every((c) => ERP_TREE_CODES.includes(c)),
                { message: 'Código fora da árvore do ERP.' }
            ),
    })
    .strict()
export type SetUserErpPermissions = z.infer<typeof setUserErpPermissionsSchema>
